export const polygonStyles = {
            strokeColor: '#FBBF24',
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: '#FBBF24',
            fillOpacity: 0.45,
}